import React, { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import classes from './dragdrop.module.scss';
import {
  Button,
  Box,
  Typography,
} from '@mui/material';


function DragDrop(props) {
  const [files, setFiles] = useState(null);
  const [key, setKey] = useState(1);

  const fileTypes = ["xlsx"];

  const handleChange = (FileList) => {
    let selFiles = Array.prototype.slice.call(FileList); //Array.from(e.target.files)
    if(selFiles.length > 0){
      setFiles(FileList);
      console.log("Selected Files" + FileList );
      props.handleOnFilesSelection(FileList);
      setKey(key + Math.random());
    }
  };

  return (
    <div>
    <FileUploader
     handleChange={handleChange} 
     name="file" 
     multiple={true}
     key={key}
     types={fileTypes}
     hoverTitle={"Drop Here"}
     onTypeError={(err) => props.handleFileSelectError()}
     onDrop={(file) => console.log("onDROP"+file)}
     onSelect={(file) => console.log("onSELECT"+file)}
     onDraggingStateChange={(dragging) => console.log("DRAGGING"+dragging)}	

     children={
     <div className={classes.box_drag_area}>
      <div> Drag and drop files here to upload or </div>
      <Button color="secondary" style={{fontSize:"14px"}} >Browse Files</Button>
      </div>
      }
     
     />
      {/* <p>{files ? `Number of File slected: ${files.length}` : "no files selected yet"}</p> */}
      </div>
  );
}

export default DragDrop;